import { FC, HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "./GuestPage.style";
import { StaticImage } from "../StaticImage";
import { Typography } from "../../core/Typography/Typography";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { Icon } from "../../core/Icon/Icon";
import { FOOTER_NAVIGATION_VODACOM } from "../../../constants/footerNavigation";
import Menu from "../MainHeader/assets/menu_1x.webp";
import Menu2x from "../MainHeader/assets/menu_2x.webp";
import Menu3x from "../MainHeader/assets/menu_3x.webp";
import { login } from "@onmo/auth";

const games = [
  "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/Galaxy-Shooters.png",
  "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/Basketball.png",
  "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/Little-Pond.png",
  "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/Fruit-Ninja.png",
  "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/Viral-Tap.png",
];

export const GuestPage: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const onRootClick = async () => {
    await login(window.location.origin);
  };

  return (
    <div className={classes.root} onClick={onRootClick}>
      <div className={classes.header} data-role="main-header">
        <StaticImage src="/pwa/vodacom/voda.svg" className={classes.logo} />
        <div className={classes.headerRight}>
          {/* <Icon
            name="icon-linear-notification"
            data-testid="notification-icon"
          /> */}
          <StaticImage
            src={Menu}
            src2x={Menu2x}
            src3x={Menu3x}
            data-testid="menu-icon"
          />
        </div>
      </div>
      <div>
        <StaticImage
          className={classes.featureImage}
          src="https://assets.onmostealth.com/static/gaming-platform/Vodacom/Free-Games.png"
        />
        <div className={classes.footerOverlay}>
          <div className={classes.content}>
            <div className={classes.title}>
              <div className={classes.text}>
                <Typography variant={TypographyVariant.HeadingH3Bold}>
                  Free Games
                </Typography>
                <Typography variant={TypographyVariant.BodyB3Regular}>
                  Short description for this category
                </Typography>
              </div>
              <div className={classes.icons}>
                <Icon name="icon-download" className={classes.icon} size={32} />
                <Icon
                  name="icon-bold-heart"
                  className={classes.icon}
                  size={32}
                />
                <Icon
                  name="icon-bold-share"
                  className={classes.icon}
                  size={32}
                />
              </div>
            </div>
            <div className={classes.games}>
              <div className={classes.gamesContent}>
                {games.map((game, idx) => (
                  <StaticImage
                    src={game}
                    key={`${game}-${idx}`}
                    className={classes.img}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className={classes.footerNav} data-role="footer-nav">
            {FOOTER_NAVIGATION_VODACOM.map((item, idx) => (
              <button
                key={item.id + idx}
                className={classes.item}
                data-testid={`${item.id}-tab`}
              >
                {item.id === "home" && <div className={classes.active} />}
                <Icon name={item.icon} className={classes.icon} />
                <Typography
                  color={TypographyColor.Primary}
                  className={classes.titleFooter}
                  lines={1}
                >
                  {t(item.title)}
                </Typography>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
